<template>
    <div>
        <!-- @TODO: Add this to a reusable component -->
        <div class="text-center">
            <div class="logo-device text-center mb-6">
                <img :src="global.app.url + 'images/logo-device.svg'" alt="Options Desk O logo" title="Options Desk" />
            </div>

            <h1 class="text-xl uppercase font-semibold mb-5">Forgot Password?</h1>
        </div>
        <!-- @ENDTODO -->

        <ValidationObserver v-slot="{ handleSubmit }" ref="passwordResetObserver">
            <form @submit.prevent="handleSubmit(handlePasswordReset)">
                <InputComponent v-model="passwordResetFormData.email" type="email" label="Email Address" placeholder="Email Address" />

                <div class="mt-8">
                    <AlertComponent :message="global.flashMessage.message" :errors="global.flashMessage.errorList" :color="global.flashMessage.color" />
                </div>

                <div class="mt-8">
                    <ButtonComponent type="submit" color="primary" label="Send Password Reset Email" :isLoading="isLoading" />
                </div>

                <div class="mt-3">
                    <router-link :to="{ name: 'login' }" class="text-white"><span class="icon-arrow-left mr-3 align-middle"></span>Back to login page</router-link>
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import ButtonComponent from "@components/buttons/ButtonComponent";
import AlertComponent from "@components/misc/AlertComponent";

export default {
    name: "ForgotPasswordPage",
    components: {
        ValidationObserver,
        InputComponent,
        ButtonComponent,
        AlertComponent
    },
    computed: {
        ...mapGetters(["global"])
    },
    data: function () {
        return {
            isLoading: false,
            passwordResetFormData:{
                email: ""
            }
        };
    },
    methods: {
        ...mapActions(['sendForgotPasswordEmail', 'setGlobalFlashResponse', 'resetGlobalFlashResponse']),
        handlePasswordReset(){
            this.resetGlobalFlashResponse(); // @TODO: Make this be actioned more dynamically without having to include it on a regular basis. Perhaps on Vue Router route change, clear the state
            this.isLoading = true;
            this.sendForgotPasswordEmail(this.passwordResetFormData).then(response => {
                this.passwordResetFormData.email = "";
                this.isLoading = false;
                this.$refs.passwordResetObserver.reset();
                this.setGlobalFlashResponse({
                    color: "green",
                    message: 'If this email address exists in our system, an email has been sent to it with further instructions.'
                });
            },
            error => {
                this.isLoading = false;
                this.setGlobalFlashResponse({
                    message: 'There was a problem trying to send the password reset email.'
                });
            })
        }
    },
};
</script>
